import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import NFTDetail from '../../components/NFTDetail'
import INFTSalesList from '../../models/INFTSalesList'
import { getNFTItem, getNFTItemFromERC721 } from '../../../../services/NFTMarketPlace/Graphquery'
import INFTItem from '../../models/INFTItem'
import NFTDetailFormater from '../../nftComponents/Details'
import { Helmet } from 'react-helmet'

const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const MarketMenu = styled.div`
  margin-top: 20px;
  width: 80%;
  display: flex;
  justify-content: flex-end;
`

export default function NFTItemDetail(props: any) {
  const {
    match: {
      params: { tokenContract, tokenId }
    }
  } = props
  /*NFT SALES LIST START*/
  const [detailsLoading, setDetailsLoading] = useState(true)
  const [tokenDetailItem, setTokenDetailItem] = useState<{ saleList: INFTSalesList[]; nftItem: INFTItem | undefined }>({
    saleList: [],
    nftItem: undefined
  })

  useEffect(() => {
    getNFTItem(tokenId, tokenContract)
      .then((response: INFTSalesList[]) => {
        getNFTItemFromERC721(tokenId, tokenContract)
          .then((ERC721Response: INFTItem | undefined) => {
            setTokenDetailItem({
              saleList: response,
              nftItem: ERC721Response
            })
            setDetailsLoading(false)
          })
          .catch((err: any) => {
            console.log(err)
            setDetailsLoading(false)
          })
      })
      .catch((err: any) => {
        console.log(err)
        setDetailsLoading(false)
      })
  }, [tokenId, tokenContract])

  let tokenItem: INFTSalesList

  const foundTokenItem: INFTSalesList | undefined = tokenDetailItem.saleList.find(
    (item: INFTSalesList) => parseInt(item.status.toString()) === 1
  )

  if (tokenDetailItem && tokenDetailItem.nftItem && foundTokenItem === undefined) {
    tokenItem = {
      id: tokenDetailItem.nftItem.id,
      tokenContract: tokenDetailItem.nftItem.contract.id,
      tokenId: parseInt(tokenDetailItem.nftItem.tokenID),
      status: "0",
      seller: tokenDetailItem.nftItem.owner.id,
      tokenUri: tokenDetailItem.nftItem.tokenURI
    }
  } else if (foundTokenItem !== undefined) {
    tokenItem = {
      ...foundTokenItem,
      status: foundTokenItem.status,
      tokenUri: tokenDetailItem && tokenDetailItem.nftItem ? tokenDetailItem.nftItem.tokenURI : ''
    }
  } else {
    const tokenItemDetail = tokenDetailItem.saleList[tokenDetailItem.saleList.length - 1]
    tokenItem = {
      ...tokenItemDetail,
      status: tokenItemDetail ? tokenItemDetail.status : "0",
      tokenUri: tokenDetailItem && tokenDetailItem.nftItem ? tokenDetailItem.nftItem.tokenURI : ''
    }
  }
  /*NFT SALES LIST END*/

  return (
    <PageWrapper>
      <Helmet>
        <title>{"Detail - YetiSwap NFT Marketplace"}</title>
      </Helmet>
      <NFTDetailFormater detailsLoading={detailsLoading} tokenItem={tokenItem} tokenContract={tokenContract} saleList={tokenDetailItem.saleList} />
    </PageWrapper>
  )
}
